
const MENU = [
  {
    id: 0,
    title: 'Рекомендации',
    path: '/goods',
    sub: () => null,
  },
  {
    id: 1,
    title: 'Популярные',
    path: '/goods/popular',
    sub: () => null,
  },
  {
    id: 2,
    title: 'Новые',
    path: '/goods/new',
    sub: () => null,
  },
]
const URL = '/suppliers/goods'
export default {
  async asyncData({ $axios }) {
    const { companys } = await $axios.$get(URL, {
      params: { limit: 10 },
    })
    return {
      companys,
    }
  },
  computed: {
    filterMenu() {
      return MENU
    },
  },
}
